import { NgIf, AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatTabNav, MatTabLink, MatTabNavPanel } from '@angular/material/tabs';
import { RouterLink } from '@angular/router';
import { RootState } from '@next/core-lib/app';
import { TranslatePipe } from '@next/core-lib/i18n';
import { RouterSelectors } from '@next/core-lib/router-store';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { map, skipWhile, switchMap, withLatestFrom } from 'rxjs/operators';

import { getHasObservations, getSelectedAnimalGroupId } from '../../store/animal-group.selectors';

@Component({
  selector: 'app-animal-group-navigation',
  templateUrl: './animal-group-navigation.component.html',
  imports: [NgIf, MatTabNav, MatTabLink, RouterLink, MatTabNavPanel, AsyncPipe, TranslatePipe],
})
export class AnimalGroupNavigationComponent {
  routeUrl$: Observable<string> = this.store.pipe(select(RouterSelectors.getPath));

  hasObservations$: Observable<boolean> = this.store.select(getHasObservations);

  isFeedAdviceApplications$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('feedadvice-applications') > 0),
  );
  isObservations$: Observable<boolean> = this.routeUrl$.pipe(
    map((url) => url.indexOf('observations') > 0),
  );
  isGeneral$: Observable<boolean> = this.isFeedAdviceApplications$.pipe(
    withLatestFrom(this.isObservations$),
    switchMap(([isFeedAdviceApplications, isObservations]) => [
      !(isFeedAdviceApplications || isObservations),
    ]),
  );

  animalGroupId: number;

  constructor(private readonly store: Store<RootState>) {
    this.store
      .select(getSelectedAnimalGroupId)
      .pipe(skipWhile((id) => id === null))
      .subscribe((id) => {
        this.animalGroupId = id;
      });
  }
}
